import { useState } from 'react'
import { useDelayedValue, useRequest, useView } from '@10000/react'
import { Box } from '../../widgets'
import { usePracticeWheel, Results as CommonResults, SquizButton } from '../common'
import { useShell } from '../../layout'

export const Results = ({ active }) => {
  const request = useRequest('squiz')
  const { presenter, result, consensusAnswers, questionIndex, options: { questionCount } } = useView('squiz')
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const includesConsensus = typeof consensusAnswers?.[0]?.answer === 'number'

  useShell({ active, mode: 'squiz', step: questionIndex + 1, max: questionCount })
  usePracticeWheel().update({ pb: 120 })

  const phases = {
    consensus: { event: 'resultsModeSet', mode: 'consensus', buttonText: 'Show consensus' },
    practice: { event: 'resultsModeSet', mode: 'practice', buttonText: 'Show practice wheel', mobileButtonText: 'Show wheel' },
    complete: { event: 'resultsComplete', buttonText: questionIndex === (questionCount - 1) ? 'See results' : `Next - Question ${questionIndex + 2}` },
  }
  const nextPhase = (result === 'practice' || (result === 'consensus' && questionIndex === (questionCount - 1))) ? 'complete'
    : (result === 'teamAverage' && includesConsensus) ? 'consensus'
      : 'practice'

  const { event, mode } = phases[nextPhase]

  // we want to delay the button text from changing after "Show practice wheel" is clicked or it looks janky
  const phaseForButtonText = useDelayedValue(nextPhase, { complete: 1000 })
  const { buttonText, mobileButtonText = '' } = phases[phaseForButtonText]

  const nextStage = () => request(event, { mode }).then(() => setButtonDisabled(true))

  return <>
    {presenter &&
      <Box
        id="next-button"
        position="absolute"
        fullWidth
        justifyContent="center"
        bottom={0}
        p={32}
        zIndex={2}
        opacity={0}
      >
        <Box maxWidth={400} fullWidth>
          <SquizButton
            onClick={nextStage}
            text={buttonText}
            mobileText={mobileButtonText}
            disabled={buttonDisabled}
          />
        </Box>
      </Box>
    }

    <CommonResults onAnimationComplete={() => setButtonDisabled(false)} />
  </>
}
